import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';

@Component({
  selector: 'app-monthselect',
  templateUrl: './monthselect.component.html',
  styleUrls: ['./monthselect.component.scss']
})
export class MonthselectComponent implements OnInit {

  MonthsListArray: any[] = [];
  years: any[] = [];

  @Input() labelMonth: string = 'g'; // Month label (optional)
  @Input() labelYear: string = 'g';  // Year label (optional)
  @Input() required: boolean = false; // Validation

  private _selectedMonth: number | null = null;
  private _selectedYear: number | null = null;

formData: { selectedMonth: number | null; selectedYear: number | null } = {
  selectedMonth: null,
  selectedYear: null
};

  @Input()
  set selectedMonth(value: number | null) {
    debugger
    this._selectedMonth = value;
    this.formData.selectedMonth = value;
    this.triggerDateRangeCalculation();
  }
  get selectedMonth(): number | null {
    return this._selectedMonth;
  }

  @Input()
  set selectedYear(value: number | null) {
    this._selectedYear = value;
    this.formData.selectedYear = value;
    this.triggerDateRangeCalculation();
  }
  get selectedYear(): number | null {
    return this._selectedYear;
  }

  @Output() dateRangeChanged = new EventEmitter<{ startDate: Date, endDate: Date }>();

  constructor(public Objects: ObjectsService) {
    this.onMonthSelectionChanged = this.onMonthSelectionChanged.bind(this);
    this.onyearselectionchanged = this.onyearselectionchanged.bind(this);
  }

  ngOnInit(): void {
    this.getMonths();
    this.generateYearOptions();
  }

  getMonths(): void {
    this.MonthsListArray = this.Objects.MonthsList;
  }

  generateYearOptions(): void {
    const currentYear = new Date().getFullYear();
    this.years = [];
    for (let year = 2024; year <= currentYear; year++) {
      this.years.push({ id: year, nameAr: year.toString() });
    }
  }

  triggerDateRangeCalculation(): void {
    if (this._selectedYear && this._selectedMonth) {
      const startDate = new Date(this._selectedYear, this._selectedMonth - 1, 1, 12); // First day
      const endDate = new Date(this._selectedYear, this._selectedMonth, 0, 12);       // Last day
      this.dateRangeChanged.emit({ startDate, endDate });
    }
  }

  onMonthSelectionChanged(e: any): void {
    this._selectedMonth = e.value;
    this.triggerDateRangeCalculation();
  }

  onyearselectionchanged(e: any): void {
    this._selectedYear = e.value;
    this.triggerDateRangeCalculation();
  }
}
